/* Visor de imágenes para CELULAR (estilo Mattelsa): al tocar una foto del
   producto se abre una "hoja" a pantalla completa con todas las fotos en fila.
   Se desliza de lado para cambiar de foto y se hace ZOOM con los dedos (pinch
   nativo del navegador). En PC no hace nada.
   IMPORTANTE: se carga en theme.liquid Y en los layouts theme.gempages.* porque
   las páginas de producto usan el layout de GemPages, no theme.liquid. */
(function () {
  window.__khalaVisor = 'cargado';
  var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };

  // Mejor resolución disponible de un <img> (lee srcset y elige la mayor)
  function bestSrc(img) {
    var best = img.currentSrc || img.getAttribute('src') || '';
    var ss = img.getAttribute('srcset');
    if (ss) {
      var max = 0;
      ss.split(',').forEach(function (part) {
        var bits = part.trim().split(/\s+/);
        var w = parseInt((bits[1] || '').replace('w', ''), 10);
        if (!isNaN(w) && w > max) { max = w; best = bits[0]; }
      });
    }
    return best;
  }

  var lb, track, counter, slidesCount = 0;
  // estado del zoom por doble toque
  var ZOOM = 2.5;
  var zoom = 1, panX = 0, panY = 0, curImg = null;

  function currentImg() {
    if (!track || !track.clientWidth) return null;
    var i = Math.round(track.scrollLeft / track.clientWidth);
    var slide = track.children[i];
    return slide ? slide.querySelector('img') : null;
  }

  function applyZoom() {
    if (!curImg) return;
    curImg.style.transformOrigin = 'center center';
    curImg.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + zoom + ')';
  }

  function clampPan() {
    if (!curImg) return;
    var w = curImg.clientWidth * zoom, h = curImg.clientHeight * zoom;
    var maxX = Math.max(0, (w - track.clientWidth) / 2);
    var maxY = Math.max(0, (h - track.clientHeight) / 2);
    panX = Math.max(-maxX, Math.min(panX, maxX));
    panY = Math.max(-maxY, Math.min(panY, maxY));
  }

  function zoomIn(cx, cy) {
    curImg = currentImg();
    if (!curImg) return;
    var r = curImg.getBoundingClientRect();
    zoom = ZOOM;
    // llevar el punto tocado hacia el centro
    panX = -ZOOM * (cx - (r.left + r.width / 2));
    panY = -ZOOM * (cy - (r.top + r.height / 2));
    clampPan();
    curImg.style.transition = 'transform .2s ease';
    applyZoom();
    // mientras está acercado: no deslizar entre fotos, sí arrastrar
    track.style.overflowX = 'hidden';
    track.style.touchAction = 'none';
  }

  function zoomOut() {
    if (curImg) {
      curImg.style.transition = 'transform .2s ease';
      curImg.style.transform = '';
    }
    zoom = 1; panX = 0; panY = 0; curImg = null;
    track.style.overflowX = '';
    track.style.touchAction = '';
  }

  function resetZoom() {
    if (curImg) curImg.style.transform = '';
    zoom = 1; panX = 0; panY = 0; curImg = null;
    if (track) { track.style.overflowX = ''; track.style.touchAction = ''; }
  }

  function build() {
    if (lb) return;
    lb = document.createElement('div');
    lb.id = 'khala-mlb';
    lb.className = 'khala-mlb';
    lb.innerHTML =
      '<button type="button" class="khala-mlb__close" aria-label="Cerrar">' +
      '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">' +
      '<path d="M5 5l10 10M15 5L5 15"/></svg></button>' +
      '<div class="khala-mlb__track"></div>' +
      '<div class="khala-mlb__counter" hidden></div>';
    document.body.appendChild(lb);
    track = lb.querySelector('.khala-mlb__track');
    counter = lb.querySelector('.khala-mlb__counter');
    lb.querySelector('.khala-mlb__close').addEventListener('click', close);
    // actualizar contador al deslizar
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        if (!track.clientWidth) return;
        var i = Math.round(track.scrollLeft / track.clientWidth) + 1;
        counter.textContent = i + ' / ' + slidesCount;
      });
    }, { passive: true });
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && lb.classList.contains('is-open')) close();
    });

    // Doble toque = acercar / alejar (centrado donde se toca)
    var lastTap = 0, lastX = 0, lastY = 0;
    track.addEventListener('touchend', function (e) {
      if (e.changedTouches.length !== 1) return;
      var t = e.changedTouches[0];
      var now = Date.now();
      if (now - lastTap < 300 && Math.abs(t.clientX - lastX) < 30 && Math.abs(t.clientY - lastY) < 30) {
        e.preventDefault();
        if (zoom > 1) zoomOut(); else zoomIn(t.clientX, t.clientY);
        lastTap = 0;
      } else {
        lastTap = now; lastX = t.clientX; lastY = t.clientY;
      }
    }, { passive: false });

    // Mientras está acercado (doble toque): arrastrar con 1 dedo para mover
    var dragging = false, sx = 0, sy = 0, spx = 0, spy = 0;
    track.addEventListener('touchstart', function (e) {
      if (zoom > 1 && e.touches.length === 1) {
        dragging = true;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
        spx = panX; spy = panY;
        if (curImg) curImg.style.transition = 'none';
      }
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (dragging && zoom > 1 && e.touches.length === 1) {
        panX = spx + (e.touches[0].clientX - sx);
        panY = spy + (e.touches[0].clientY - sy);
        clampPan();
        applyZoom();
      }
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (e.touches.length === 0) dragging = false;
    }, { passive: true });
  }

  function open(srcs, startIndex) {
    build();
    resetZoom();
    slidesCount = srcs.length;
    track.innerHTML = srcs.map(function (s) {
      return '<div class="khala-mlb__slide"><img src="' + s + '" alt="" draggable="false"></div>';
    }).join('');
    counter.hidden = slidesCount < 2;
    counter.textContent = (startIndex + 1) + ' / ' + slidesCount;
    lb.classList.add('is-open');
    document.body.classList.add('khala-mlb-open');
    // posicionar en la foto tocada
    requestAnimationFrame(function () {
      track.scrollLeft = startIndex * track.clientWidth;
    });
    // permitir cerrar con el botón "atrás" del celular
    try { history.pushState({ khalaMlb: 1 }, ''); } catch (err) {}
  }

  function close() {
    if (!lb) return;
    resetZoom();
    lb.classList.remove('is-open');
    document.body.classList.remove('khala-mlb-open');
    track.innerHTML = '';
    if (history.state && history.state.khalaMlb) { try { history.back(); } catch (err) {} }
  }

  window.addEventListener('popstate', function () {
    if (lb && lb.classList.contains('is-open')) {
      lb.classList.remove('is-open');
      document.body.classList.remove('khala-mlb-open');
      track.innerHTML = '';
    }
  });

  // URL de mejor calidad para una foto de GemPages (usa base-src = original)
  function gpSrc(img) {
    return img.getAttribute('base-src') || img.currentSrc || img.getAttribute('src') || '';
  }

  // Toque en una foto del producto → abrir el visor.
  // Soporta la galería de Dawn (.product__media-item) y la de GemPages
  // (.gp-gallery-image-item).
  document.addEventListener('click', function (e) {
    if (!isMobile()) return;

    // --- GemPages ---
    var gpItem = e.target.closest('.gp-gallery-image-item, .gp-image-item');
    if (gpItem) {
      var scope = gpItem.closest('.gem-slider, .gp-product-images-gallery, gp-product-images') || document;
      var seen = {}, srcs = [], idx = 0;
      var tapped = gpItem.querySelector('img');
      var tappedKey = tapped ? gpSrc(tapped).split('?')[0] : '';
      Array.prototype.slice.call(scope.querySelectorAll('.gp-gallery-image-item, .gp-image-item'))
        .forEach(function (it) {
          var mt = it.getAttribute('media-type');
          if (mt && mt !== 'image') return; // saltar videos
          var img = it.querySelector('img');
          if (!img) return;
          var s = gpSrc(img);
          if (!s) return;
          var key = s.split('?')[0];
          if (seen[key]) return;
          seen[key] = 1;
          if (key === tappedKey) idx = srcs.length;
          srcs.push(s);
        });
      if (!srcs.length) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      open(srcs, idx);
      return;
    }

    // --- Dawn ---
    var item = e.target.closest('.product__media-item');
    if (!item) return;
    var gallery = item.closest('media-gallery, .product-media-gallery, .product__media-list');
    if (!gallery) return;
    e.preventDefault();
    e.stopPropagation();
    var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'))
      .filter(function (li) {
        return !li.hidden && li.style.display !== 'none' && li.querySelector('img');
      });
    var dsrcs = items.map(function (li) { return bestSrc(li.querySelector('img')); });
    if (!dsrcs.length) return;
    var didx = items.indexOf(item);
    open(dsrcs, didx < 0 ? 0 : didx);
  }, true);
}());
